var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"เลือกประเภททรัพย์สิน","disabled":_vm.disabled},model:{value:(_vm.source),callback:function ($$v) {_vm.source=$$v},expression:"source"}},_vm._l((_vm.optionList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }